"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cucumber_expressions_1 = require("@cucumber/cucumber-expressions");
var language_service_1 = require("@cucumber/language-service");
var wasm_1 = require("@cucumber/language-service/wasm");
var monaco = __importStar(require("monaco-editor/esm/vs/editor/editor.api"));
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var index_js_1 = require("../src/index.js");
var MonacoEditor_js_1 = require("./MonacoEditor.js");
function makeConfigureEditor() {
    return __awaiter(this, void 0, void 0, function () {
        var adapter, expressionBuilder, sources, _a, expressionLinks, errors, errors_1, errors_1_1, error, expressions, registry, docs, index;
        var e_1, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    monaco.languages.register({ id: 'typescript' });
                    adapter = new wasm_1.WasmParserAdapter('.');
                    return [4 /*yield*/, adapter.init()];
                case 1:
                    _c.sent();
                    expressionBuilder = new language_service_1.ExpressionBuilder(adapter);
                    sources = [
                        {
                            languageName: 'java',
                            uri: 'file:///tmp/StepDefinitions.java',
                            content: "class StepDefinitions {\n    @Given(\"I have {int} cukes in my belly\"  )\n    void method1() {\n    }\n\n    @Given(\"there are {int} blind mice\")\n    void method2() {\n    }\n\n    @Given(\"there is/are some/none/1 apple(s)\")\n    void method2() {\n    }\n}\n",
                        },
                    ];
                    _a = expressionBuilder.build(sources, []), expressionLinks = _a.expressionLinks, errors = _a.errors;
                    try {
                        for (errors_1 = __values(errors), errors_1_1 = errors_1.next(); !errors_1_1.done; errors_1_1 = errors_1.next()) {
                            error = errors_1_1.value;
                            console.error(error);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (errors_1_1 && !errors_1_1.done && (_b = errors_1.return)) _b.call(errors_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    expressions = expressionLinks.map(function (link) { return link.expression; });
                    registry = new cucumber_expressions_1.ParameterTypeRegistry();
                    docs = (0, language_service_1.buildSuggestions)(registry, ['I have 42 cukes in my belly', 'I have 96 cukes in my belly', 'there are 38 blind mice'], expressions);
                    index = (0, language_service_1.jsSearchIndex)(docs);
                    return [2 /*return*/, (0, index_js_1.configureMonaco)(monaco, index, expressions)];
            }
        });
    });
}
var value = "@foo\nFeature: Hello\nScenario: Hi\n  Given I have 58 cukes in my belly\n  And this is an undefined step\n    | some | poorly |\n    | formatted | table |\n";
var options = {
    value: value,
    language: 'gherkin',
    theme: 'vs-dark',
    // semantic tokens provider is disabled by default
    'semanticHighlighting.enabled': true,
};
var javascriptEditor = document.getElementById('editor1');
var reactEditor = document.getElementById('editor2');
makeConfigureEditor()
    .then(function (configureEditor) {
    // @ts-ignore
    configureEditor(monaco.editor.create(javascriptEditor, options));
    // @ts-ignore
    var root = (0, client_1.createRoot)(reactEditor);
    root.render(react_1.default.createElement(MonacoEditor_js_1.MonacoEditor, { options: options, className: "editor", configure: configureEditor }));
})
    .catch(function (err) { return console.error(err.stack); });
//# sourceMappingURL=index.js.map